import { SERVICE } from '@src/api/types/shared/serviceType';
import CommonHelmet from '@src/components/CommonHelmet';
import CompanyGuard from '@src/components/guard/CompanyGuard';
import { COMPANY_ROLE } from '@src/enum/companyRoleEnum';
import DxDiagnosisAnswers from '@src/features/company/dx-diagnosis/DxDiagnosisAnswers';
import CompanyNoMenusLayout from '@src/layouts/company/CompanyNoMenusLayout';

function CompanyDxDiagnosisAnswers() {
  return (
    <CompanyGuard
      canRoles={[COMPANY_ROLE.ADMIN]}
      canService={[SERVICE.DX_DIAGNOSIS]}
    >
      <CompanyNoMenusLayout>
        <CommonHelmet />
        <DxDiagnosisAnswers />
      </CompanyNoMenusLayout>
    </CompanyGuard>
  );
}

export default CompanyDxDiagnosisAnswers;
